// Import model
import { DataviewRoomSelectionResponse } from '../models/DataviewRoomSelectionResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DataView } from '../models/DataView';
import { FilterRoomSelectionRequest } from '../models/FilterRoomSelectionRequest';
import { RoomSelection } from '../models/RoomSelection';

// Import dependency serializers (for complex types)
import { DataViewSerializer } from './DataViewSerializer';
import { FilterRoomSelectionRequestSerializer } from './FilterRoomSelectionRequestSerializer';
import { RoomSelectionSerializer } from './RoomSelectionSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewRoomSelectionResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewRoomSelectionResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewRoomSelectionResponse instance
   */
  static deserialize(json: string): DataviewRoomSelectionResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewRoomSelectionResponse instance
   */
  static fromObject(obj: any): DataviewRoomSelectionResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewRoomSelectionResponse');
    }


    const instance: DataviewRoomSelectionResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        RoomSelectionSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterRoomSelectionRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewRoomSelectionResponse instances
   */
  static deserializeArray(json: string): DataviewRoomSelectionResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewRoomSelectionResponse instance to a JSON string
   */
  static serialize(instance: DataviewRoomSelectionResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewRoomSelectionResponse instance to a plain object
   */
  static toObject(instance: DataviewRoomSelectionResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        RoomSelectionSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterRoomSelectionRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewRoomSelectionResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewRoomSelectionResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
